import { useState, useEffect, useRef } from 'react';
export default function useCookieConsentGate(renderCookieConsentPrompt) {
  const [hasCookieConsentExited, setHasCookieConsentExited] = useState(!renderCookieConsentPrompt);
  const prevRef = useRef(renderCookieConsentPrompt);

  // Reset the gate when cookie consent is re-required.
  useEffect(() => {
    const prev = prevRef.current;
    prevRef.current = renderCookieConsentPrompt;
    if (renderCookieConsentPrompt && !prev) {
      setHasCookieConsentExited(false);
    }
  }, [renderCookieConsentPrompt]);
  const handleCookieConsentExited = () => setHasCookieConsentExited(true);
  return {
    hasCookieConsentExited,
    handleCookieConsentExited
  };
}